require('./common/recaptchav3');
require('./common/currentLocale');
require('./components/dropdown-select-lang');
require('./common/redirectUs');
